module.exports = __webpack_public_path__ + "Roboto-Regular.3e1af3ef546b9e6ecef9f3ba197bf7d2.hashedasset.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/Roboto/Roboto-Regular.ttf
// module id = 434
// module chunks = 8